const enum StepTaskApprovalStatus {
  Approved = 0,
  Rejected = 1
}
export default StepTaskApprovalStatus;
